import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  container: {
    width: { md: '271px' },
    flexShrink: 0,
    backgroundColor: 'var(--grey-100)',
    borderRight: '2px solid var(--blue-500)'
  } satisfies SxProps<Theme>,
  header: {
    backgroundColor: 'var(--blue-700)',
    px: '16px',
    py: '8px'
  } satisfies SxProps<Theme>,
  headerTitle: {
    color: 'var(--white)'
  } satisfies SxProps<Theme>,
  hint: {
    backgroundColor: 'var(--blue-50)',
    px: '16px',
    py: '12px'
  } satisfies SxProps<Theme>,
  hintText: {
    color: 'var(--grey-900)'
  } satisfies SxProps<Theme>,
  item: (selected: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minHeight: '50px',
    px: '16px',
    cursor: 'pointer',
    borderRight: selected ? '8px solid var(--blue-500)' : '8px solid transparent',
    backgroundColor: selected ? 'var(--white)' : 'transparent',
    color: 'var(--grey-700)'
  } satisfies SxProps<Theme>),
  itemLabel: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'inherit'
  } satisfies SxProps<Theme>
}
